import { DsrPermissionApi } from "@/api";
import i18n from "@/i18n";
import { showSuccessSnackbar, showErrorSnackbar } from "@/utilities/snackbar";

/**
 * Default di sistema, ultimo anello della catena di eredità. Sono permissivi di proposito: a
 * tabella vuota il comportamento è quello precedente alla feature. Stessi valori del backend
 * (`DsrUserPermissions.SystemDefault*`).
 */
export const SYSTEM_DEFAULT_READ_ONLY = false;
export const SYSTEM_DEFAULT_EXPORT_ENABLED = true;

/** Permessi permissivi, usati finché la risposta dell'API non è arrivata. */
export function permissivePermissions() {
  return {
    readOnly: SYSTEM_DEFAULT_READ_ONLY,
    exportAllowedByPermission: SYSTEM_DEFAULT_EXPORT_ENABLED,
    dsrDownloadEnabled: false,
    exportEnabled: false,
  };
}

export async function getMyPermissions(enterpriseId) {
  const { data } = await DsrPermissionApi.getMyPermissions(enterpriseId);
  return data;
}

export async function getEnterprisePermissions(enterpriseId) {
  const { data } = await DsrPermissionApi.getEnterprisePermissions(
    enterpriseId
  );
  return data;
}

export async function setEnterpriseDefault(enterpriseId, payload) {
  try {
    const { data } = await DsrPermissionApi.setEnterpriseDefault(
      enterpriseId,
      payload
    );
    showSuccessSnackbar(200, i18n.t("dsr-license.permissions.saved"));
    return data;
  } catch (ex) {
    showErrorSnackbar(ex);
    throw ex;
  }
}

export async function setUserOverride(enterpriseId, userId, payload) {
  try {
    const { data } = await DsrPermissionApi.setUserOverride(
      enterpriseId,
      userId,
      payload
    );
    showSuccessSnackbar(200, i18n.t("dsr-license.permissions.saved"));
    return data;
  } catch (ex) {
    showErrorSnackbar(ex);
    throw ex;
  }
}

/**
 * Replica lato client della regola di dominio: `override ?? default azienda ?? default di sistema`.
 * Serve a mostrare "eredita (sola lettura)" senza un secondo giro sul server; la fonte di verità
 * resta il backend, che risponde 403 comunque.
 */
export function effective(override, enterpriseDefault, systemDefault) {
  if (override !== null && override !== undefined) return override;
  if (enterpriseDefault !== null && enterpriseDefault !== undefined)
    return enterpriseDefault;
  return systemDefault;
}

/** Il valore della riga è ereditato dal livello superiore, non impostato su di essa. */
export function isInherited(rawValue) {
  return rawValue === null || rawValue === undefined;
}
